import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Checkbox,
} from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaCheckbox } from '@/packages/courses/types/schema';
import type { CatalogUrlKey } from '@/packages/courses/types/url-params';

interface FilterCheckboxProps extends FilterSchemaCheckbox {
  id: CatalogUrlKey;
}

export const FilterCheckbox = ({ id, title, options }: FilterCheckboxProps) => {
  const { params, actions } = useCatalogFilters();
  const selected = params[id] ?? [];

  const handleToggle = (value: string) => {
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    actions.setParam(id, next.length ? next : undefined);
  };

  return (
    <FormControl
      component="fieldset"
      id={id}
      aria-labelledby={`${id}-label`}
    >
      <FormLabel component="legend" id={`${id}-label`}>
        {title}
      </FormLabel>
      <FormGroup>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            control={
              <Checkbox
                checked={selected.includes(opt.value)}
                onChange={() => handleToggle(opt.value)}
                name={opt.value}
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};
